import { getBonusMessagesHandler, getStatusHandler } from "../../../constants";
import { parseSettlementStatus } from "../../parseSettlementStatus";
const mapBetStatusToEarlyWinStatus = new Proxy({
    Open: "Active",
    Won: "Active",
    Lost: "Active",
    CashOut: "Inactive",
    Cancelled: "Inactive",
    DeadHeatReduction: "Active",
    Void: "Inactive",
}, getStatusHandler);
const mapBetStatusToEarlyWinPhrases = new Proxy({
    Open: ["CashOutQualifyingBetDisclaimer"],
    Won: [],
    Lost: [],
    CashOut: ["EarlyWinCashedOut"],
    Cancelled: ["EarlyWinReturned"],
    DeadHeatReduction: [],
    Void: ["EarlyWinReturned"],
}, getBonusMessagesHandler);
export function parseEarlyWinBonusMessagesAndState(bet, dictionary) {
    const settlementStatus = parseSettlementStatus(bet.settlementStatus);
    let bonusStatus = mapBetStatusToEarlyWinStatus[settlementStatus];
    let bonusMessages = mapBetStatusToEarlyWinPhrases[settlementStatus].map(phrase => ({
        type: "Regular",
        text: dictionary.myBetsDictionary[phrase]
    }));
    if (settlementStatus === "DeadHeatReduction") {
        bonusMessages = [{
                type: "Regular",
                text: dictionary.myBetsDictionary.EarlyWinNotApplied,
            }];
        bonusStatus = "Inactive";
    }
    const eligibleCount = bet.selections.reduce((count, s) => {
        let total = s.isEarlyWinEligible ? 1 : 0;
        if (s.nestedSGPSelections) {
            total += s.nestedSGPSelections.filter(ns => ns.isEarlyWinEligible).length;
        }
        return count + total;
    }, 0);
    if (eligibleCount > 0 && bet.type !== "Single" && bet.settlementStatus === "Open") {
        bonusMessages = [
            {
                type: "Regular",
                text: dictionary.myBetsDictionary.EarlyWinEligibleForXPicks.replace("{0}", String(eligibleCount)),
            },
            ...bonusMessages,
        ];
    }
    return [bonusStatus, bonusMessages];
}
//# sourceMappingURL=parseEarlyWinBonusMessagesAndState.js.map